module.exports = "/_next/static/videos/teaser2-slice-2-3a54b8cf58dcf3e5ac6b735fd337045c.mp4";